import { compose } from 'recompose';

import CaseStudiesFilter from './CaseStudiesFilter';

const enhance = compose();

export default enhance(CaseStudiesFilter);
